



















































































































































































import { Component } from "vue-property-decorator";
import { Getter } from "vuex-class";
import CallCenterUsersFilter from "@/components/UserManagement/CallCenterUsersFilter.vue";
import {ScrollButton} from "wings-ui-components";
import BaseItemsPage from "@/pages/Pages/BaseItemsPage";
import { CallCenterUserItem } from "@/store/user_management/callcenter_users/types";

@Component({ components: {CallCenterUsersFilter, ScrollButton } })
export default class CallCenterUsers extends BaseItemsPage<CallCenterUserItem> {
  @Getter("callCenterUsers") itemsResponse: any;

  private is_show_filter = false;

  currentSort = "name";
  currentSortOrder = "desc";
  tableFields = ["name", "email", "partner", "status"];

  getData(): any {
    return this.itemsResponse;
  }

}
